class countdownTimerPopup extends HTMLElement {
  constructor() {
    super();
    this.close = this.querySelector('.ctp_close_button');
    let timerEndDate = new Date(this.querySelector('countdown-timer').dataset.endDate).getTime();
    let timerCurrentDate = new Date().getTime();
    let distance = timerEndDate - timerCurrentDate;
    let countdownTimerPopupStatus = sessionStorage.getItem("countdownTimerPopup");

    if (countdownTimerPopupStatus != 'closed' && distance > 0) {
      setTimeout(() => {
        this.show();
      }, 8000);
    }

    this.addEventListener('click', (event) => {
      if (event.target.closest('.ctp_close_button') || event.target === this) {
        this.hide()
      }
    })
  }

  show() {
    this.classList.add('show_timer')
    document.body.classList.add('overflow-hidden');
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.classList.remove('show_timer')
    sessionStorage.setItem("countdownTimerPopup", "closed");
  }
}

customElements.define('popup-timer', countdownTimerPopup);